export default {
    409: 'pages.registration.error.account.verification.failed',
    422: 'pages.registration.error.account.verification.failed',
};
